export default{
    en:{
        tab:{
            rankJournal:'Ranking of Journal',
            rankS2Journal:'Ranking of Journal',
        },
        list:{
            idx1:'Category',
            issnno:'ISSN No.',
            journal:'Title of Journal',
            publish:'Publisher',
            grade:'Rank of Journal',
            addYear:'Year of KCI(Accredited)',
            major:'Dept./College',
        },
        help:{
            content:''
        }
    },
    ko:{
        tab:{
            rankJournal:'학술지등급',
            rankS2Journal:'학술지등급',
        },
        list:{
            idx1:'학술지구분',
            issnno:'ISSN No.',
            journal:'학술지명',
            publish:'발행기관',
            grade:'학술지 등급',
            addYear:'등재/등재후보 선정년도',
            major:'대학/학과',
        },
        help:{
            content:''
        }
    }
}